export enum ClientErrorCodes {
  START_QUIZ_ERROR = 'starting the quiz',
  FOLLOWER_JOIN_QUIZ_ERROR = 'joining quiz',
  QUESTION_SCORE_ERROR = 'loading the results',
  TOO_MANY_PLAYERS = 'too_many_players',
  VOTE_FAILURE = 'vote_failure',
  MULTIPLE_DEVICES = 'multiple_devices',
  RESULTS_FETCH = 'results_fetch',
  NO_CONNECTION = 'no_connection',
}

export enum ErrorCodes {
  NO_AVAILABLE_QUIZ = 'no_available_quiz',
  CREATE_QUIZ_ERROR = 'create_quiz_error',
  FAILED_TO_POST_VOTE = 'failed_to_post_vote',
  PLAYER_VOTED_TOO_SLOW = 'player_voted_too_slow',
  PLAYER_VOTED_TOO_FAST = 'player_voted_too_fast',
  PLAYER_HAS_ALREADY_VOTED = 'player_has_already_voted',
  MISSING_PARAMETER = 'missing_parameter',
  FAILED_TO_CREATE_OR_UPDATE_PLAYER = 'failed_to_create_or_update_player',
  FAILED_TO_GET_RESULT = 'failed_to_get_result',
  FAILED_TO_GET_RESULT_GAME_STATE = 'failed_to_get_result_game_state',
}
